export const supportedLanguages = {
  English: {
    shortCodeName: 'en',
    largeCodeName: 'en-us',
    userFriendlyName: 'English (US)'
  },
  Spanish: {
    shortCodeName: 'es',
    largeCodeName: 'es-mx',
    userFriendlyName: 'Español'
  },
  French: {
    shortCodeName: 'fr',
    largeCodeName: 'fr-fr',
    userFriendlyName: 'Français'
  },
  CanadianFrench: {
    shortCodeName: 'fr-CA',
    largeCodeName: 'fr-ca',
    userFriendlyName: 'Français (CA)'
  },
  Polish: {
    shortCodeName: 'pl',
    largeCodeName: 'pl-pl',
    userFriendlyName: 'Polski'
  }
} as const

type Keys = keyof typeof supportedLanguages
export type SupportedLanguage = (typeof supportedLanguages)[Keys]

export const supportedLanguagesList = Object.values(supportedLanguages)
export const defaultContentLanguage = supportedLanguages.English
export const supportedLanguagesShortCodeNames: SupportedLanguage['shortCodeName'][] = supportedLanguagesList.map(
  ({ shortCodeName }) => shortCodeName
)
export const supportedLanguagesLargeCodeNames: SupportedLanguage['largeCodeName'][] = supportedLanguagesList.map(
  ({ largeCodeName }) => largeCodeName
)

export const i18nOptions = {
  supportedLngs: supportedLanguagesShortCodeNames,
  fallbackLng: supportedLanguages.English.shortCodeName,
  defaultNS: 'common',
  react: { useSuspense: false }
}
